<template>
  <form
    ref="form"
    class="semi-quote-form"
    :action="actionUrl"
    method="POST"
    novalidate
    @submit.prevent="sendForm"
  >
    <input type="hidden" name="_token" :value="csrf" />

    <div class="form-group">
      <label for="semi-name">Nombre</label>
      <input
        id="semi-name"
        v-model.trim="$v.form.name.$model"
        :class="inputClass($v.form.name)"
        name="name"
        type="text"
      />
      <div v-if="$v.form.name.$dirty" class="error-data">
        <span v-if="!$v.form.name.required">Campo necesario</span>
      </div>
    </div>

    <div class="form-group">
      <label for="semi-lastname">Apellidos</label>
      <input
        id="semi-lastname"
        v-model.trim="$v.form.lastname.$model"
        :class="inputClass($v.form.lastname)"
        name="lastname"
        type="text"
      />
      <div v-if="$v.form.lastname.$dirty" class="error-data">
        <span v-if="!$v.form.lastname.required">Campo necesario</span>
      </div>
    </div>

    <div class="form-group">
      <label for="semi-rut">RUT</label>
      <input
        id="semi-rut"
        v-model.trim="$v.form.rut.$model"
        v-rut:live
        :class="inputClass($v.form.rut)"
        name="rut"
        type="text"
      />
      <div v-if="$v.form.rut.$dirty" class="error-data">
        <span v-if="!$v.form.rut.required">Campo necesario</span>
        <span v-if="$v.form.rut.required && (!$v.form.rut.rutValidation || !$v.form.rut.minLength)">
          RUT inválido
        </span>
      </div>
    </div>

    <div class="form-group">
      <label for="semi-phone">Teléfono</label>
      <input
        id="semi-phone"
        v-model.trim="$v.form.phone.$model"
        :class="inputClass($v.form.phone)"
        maxlength="9"
        name="phone"
        type="tel"
        @keypress="onlyNumber"
      />
      <div v-if="$v.form.phone.$dirty" class="error-data">
        <span v-if="!$v.form.phone.required">Campo necesario</span>
        <span
          v-if="$v.form.phone.required && (!$v.form.phone.minLength || !$v.form.phone.maxLength)"
        >
          Teléfono inválido
        </span>
      </div>
    </div>

    <div class="form-group">
      <label for="semi-email">Email</label>
      <input
        id="semi-email"
        v-model.trim="$v.form.email.$model"
        :class="inputClass($v.form.email)"
        name="email"
        type="email"
      />
      <div v-if="$v.form.email.$dirty" class="error-data">
        <span v-if="!$v.form.email.required">Campo necesario</span>
        <span v-if="$v.form.email.required && !$v.form.email.email">Email inválido</span>
      </div>
    </div>

    <div class="form-group">
      <label for="semi-income">Selecciona tu rango de renta líquida</label>
      <select
        id="semi-income"
        v-model="$v.form.income.$model"
        :class="inputClass($v.form.income)"
        name="income"
      >
        <option value="">Selecciona una opción</option>
        <option v-for="income in incomeOptions" :key="income" :value="income">
          {{ income }}
        </option>
      </select>
      <div v-if="$v.form.income.$dirty" class="error-data">
        <span v-if="!$v.form.income.required">Campo necesario</span>
      </div>
    </div>

    <fieldset class="semi-checkbox-group mb-4">
      <legend>
        <span class="semi-question-main"
          >¿Cerca de qué estación de metro te gustaría vivir o invertir?</span
        >
        <span class="semi-question-helper">Selecciona una o más estaciones.</span>
      </legend>
      <div class="row">
        <div
          v-for="(group, groupIndex) in stationGroups"
          :key="`station-group-${groupIndex}`"
          class="col-12 col-md-6"
        >
          <div
            v-for="station in group"
            :key="station.id"
            class="custom-control custom-checkbox mb-2"
          >
            <input
              :id="station.id"
              v-model="$v.form.stations.$model"
              :value="station.value"
              class="custom-control-input"
              name="stations[]"
              type="checkbox"
            />
            <label class="custom-control-label" :for="station.id">{{ station.label }}</label>
          </div>
        </div>
      </div>
      <div v-if="$v.form.stations.$dirty" class="error-data">
        <span v-if="!$v.form.stations.hasStations">Selecciona al menos una estación</span>
      </div>
    </fieldset>

    <privacy-consent
      id="semi-privacy"
      v-model="$v.form.privacy.$model"
      :invalid="$v.form.privacy.$dirty && !$v.form.privacy.accepted"
      :privacy-url="rutaBases"
    />
    <button type="submit" class="btn semi-submit-btn mb-4" :disabled="formLoading">
      {{ btnText }}
    </button>
  </form>
</template>

<script>
  import { required, email, minLength, maxLength } from 'vuelidate/lib/validators';
  import { rutInputDirective, rutValidator } from 'vue-dni';
  import Vue from 'vue';
  import PrivacyConsent from '../../components/PrivacyConsent.vue';

  Vue.directive('rut', rutInputDirective);

  const hasStations = (stations) => Array.isArray(stations) && stations.length > 0;
  const accepted = (value) => value === true;

  export default {
    name: 'form-semi-nuevos',
    components: { PrivacyConsent },
    props: {
      actionUrl: {
        type: String,
        default: '/add-contact-semi-nuevos',
      },
      rutaBases: {
        type: String,
      },
    },
    data: () => ({
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      formLoading: false,
      btnText: 'ENVIAR',
      incomeOptions: [
        '$1.200.000 - $1.400.000',
        '$1.400.001 - $1.600.000',
        '$1.600.001 - $1.800.000',
        '$1.800.001 - $2.000.000',
        '$2.000.001 - más',
      ],
      stationGroups: [
        [
          { id: 'station-santa-ana', label: 'Metro Santa Ana', value: 'Metro Santa Ana' },
          { id: 'station-parque', label: 'Metro Parque Almagro', value: 'Metro Parque Almagro' },
          { id: 'station-hurtado', label: 'San Alberto Hurtado', value: 'San Alberto Hurtado' },
        ],
        [
          {
            id: 'station-metro-hurtado',
            label: 'Metro San Alberto Hurtado',
            value: 'Metro San Alberto Hurtado',
          },
          {
            id: 'station-hospitales',
            label: 'Metro Hospitales / Plaza Chacabuco',
            value: 'Metro Hospitales / Plaza Chacabuco',
          },
          { id: 'station-undefined', label: 'Aún no lo defino', value: 'Aún no lo defino' },
        ],
      ],
      form: {
        name: '',
        lastname: '',
        rut: '',
        phone: '',
        email: '',
        income: '',
        stations: [],
        privacy: false,
      },
    }),
    methods: {
      inputClass(field) {
        return !field.$anyError ? 'form-control' : 'form-control form-error';
      },
      onlyNumber($event) {
        const keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
          $event.preventDefault();
        }
      },
      sendForm() {
        this.$v.form.$touch();
        if (this.$v.form.$invalid) {
          return;
        }

        this.formLoading = true;
        this.btnText = 'Enviando...';

        this.$refs.form.submit();
      },
    },
    validations: {
      form: {
        name: { required },
        lastname: { required },
        rut: {
          required,
          rutValidation: rutValidator,
          minLength: minLength(9),
        },
        phone: {
          required,
          minLength: minLength(9),
          maxLength: maxLength(9),
        },
        email: {
          required,
          email,
        },
        income: { required },
        stations: { hasStations },
        privacy: { accepted },
      },
    },
  };
</script>
